module.exports = __webpack_public_path__ + "static/media/powerButtonHover.46c62d72.svg";